// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"1":"ba32120f","2":"56e581e4","3":"f85fe2ee","4":"5c708c96","5":"0df5a4b5","6":"b178306a","7":"48989f2c","8":"ed8d689a","9":"60069444","10":"c6e3c93e","11":"bb9bcac0"}[chunkId] + ".chunk.js";
};